const ViewModeService = {
  setViewMode: (viewMode: string) => {
    sessionStorage.setItem("pepper-view-mode", viewMode);
  },

  getViewMode: () => {
    return sessionStorage.getItem("pepper-view-mode");
  },
};

export default ViewModeService;
